import React from 'react';
import clsx from 'clsx';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';

interface ComponentProps {
  locationPoint?: string;
  locationAddress?: string;
  locationDate?: any;
  locationDisabled?: boolean;
  wrapper?: string;
  through?: string;
  locationDesc?: string;
  dataTestIdLocationName?: string;
  render?: boolean;
  timezoneId?: string;
}

const ExpeditionLocation: React.FC<ComponentProps> = ({
  locationPoint,
  locationAddress,
  locationDate,
  locationDisabled,
  wrapper,
  through,
  locationDesc,
  render = true,
  timezoneId,
  dataTestIdLocationName,
}) => {
  const className = clsx('location', {
    'p-col-12 p-md-6 p-d-flex p-flex-nowrap': locationDisabled === false,
    'location-disabled p-col-12 p-md-6 p-d-flex p-flex-nowrap': locationDisabled === true,
    'p-d-flex p-flex-nowrap': wrapper === 'LARGE'
  });

  return (
    <>
      {!render && <div className={className}></div>}
      {render &&
        <div className={className}>
          <div className="p-mr-1 items-center location-point ">
            <small>{locationPoint}</small>
          </div>
          <div className="p-d-flex p-flex-wrap items-center">
            {locationAddress &&
              <div className="p-mr-3 text-content-primary">
                {locationAddress && <strong className="location-name" data-testid={dataTestIdLocationName}>{locationAddress}</strong>}
                {locationDesc && <span className="delimiter p-pr-2">,</span>}
                {locationDesc && <small className="location-name-decscription">{locationDesc}</small>}
              </div>
            }
            <div className="flex flex-col gap-1">
              {locationDate && <small className="location-date text-content-secondary"
                                      data-testid={`${dataTestIdLocationName}-dateRange`}>{locationDate}</small>}
            </div>
            <COTimezone dataTestId={`${dataTestIdLocationName}-timezone`} timezoneId={timezoneId}/>
            {through && <small className="text-content-primary">{through}</small>}
          </div>
        </div>
      }
    </>);

};
export default ExpeditionLocation;